import { render } from "./ForgotPassowrd.vue?vue&type=template&id=4dd1ddcb"
import script from "./ForgotPassowrd.vue?vue&type=script&lang=js"
export * from "./ForgotPassowrd.vue?vue&type=script&lang=js"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__